module.exports = __webpack_public_path__ + "img/undraw_Email_campaign_re_m6k5.0b6abad3.svg";